export default __webpack_public_path__ + "src/_images/QS_LocationsIcon.png";